'use client'

import { HeaderDesktopNavigationSubmenus } from '@/src/domains/header/components/Header/HeaderDesktopNavigation/HeaderDesktopNavigationSubmenus'
import { useHeaderClinicSubmenus } from '@/src/domains/header/components/Header/hooks/useHeaderClinicSubmenus'
import { StrapiMenuSpecialFunction } from '@/src/domains/strapi/constants'

import { HeaderDesktopNavigationClinicImages } from './HeaderDesktopNavigationClinicImages'

export const HeaderDesktopNavigationClinic = () => {
  const menus = useHeaderClinicSubmenus()

  return (
    <HeaderDesktopNavigationSubmenus
      menus={menus}
      renderMenu={({ special_function }, defaultMenu) => {
        return (
          <>
            {defaultMenu}
            {special_function === StrapiMenuSpecialFunction.CLINIC_LOCATION ? (
              <HeaderDesktopNavigationClinicImages />
            ) : null}
          </>
        )
      }}
    />
  )
}
